// Form phát lệnh thô (#/jobs/new) — từ 05/10/2026 (N11) chỉ còn trong Chế độ kỹ thuật; Boss thường được chuyển sang Kịch bản.
// Toàn bộ form nằm ở khung dùng chung pages/phat-lenh-khung.ts (dayDu: true): kịch bản (gộp từ bot đã tick), chế độ, giong_nhau/chia_deu,
// tham số chung + theo bot, giãn cách, canary, tự duyệt bước rủi ro cao, hết giờ; /api/jobs/preview khoá bot + cảnh báo.
// Gói H: store.draftSpec (spec AI soạn từ lệnh chữ) → điền sẵn form ("Sửa trong form"), đọc xong xoá.
import { errMsg } from "../api";
import { gen, h } from "../dom";
import { loadBots, sortBots, store } from "../store";
import type { Bot } from "../types";
import { taoKhungPhatLenh } from "./phat-lenh-khung";

export async function renderJobNew(root: HTMLElement, _p: Record<string, string>, query: URLSearchParams): Promise<() => void> {
  const alive = gen("job-new");
  root.append(h("h1", {}, "Phát lệnh cho nhiều bot"));
  const loading = h("p", { class: "muted" }, "Đang tải bot…");
  root.append(loading);
  let bots: Bot[];
  try {
    bots = sortBots(await loadBots());
  } catch (e) {
    if (!alive()) return () => {};
    loading.replaceWith(h("div", { class: "err-box", "data-testid": "page-error" }, "Không tải được bot: ", errMsg(e)));
    return () => {};
  }
  if (!alive()) return () => {};
  loading.remove();

  let chonSan = (query.get("botIds") ?? "").split(",").map((s) => s.trim()).filter((id) => bots.some((b) => b.id === id));
  if (!chonSan.length) chonSan = [...store.ticked].filter((id) => bots.some((b) => b.id === id));
  const khung = taoKhungPhatLenh(root, { bots, chonSan, dayDu: true, alive });
  const pre = store.draftSpec;
  store.draftSpec = null;
  if (pre) khung.applyPrefill(pre);
  khung.batDau();
  return () => khung.cleanup();
}
